import BillingPlan from "./BillingPlan";
export default BillingPlan;